<div class="employees" *ngIf="participants && participants.length > 0">
    <div *ngFor="let participant of participants; let i = index" class="employee">
        <label class="checkboxlabel">
            <span>{{ i + 1 }}.</span>
            <div *ngIf="participant">
                <span class="main">
                    {{ participant.person.salutation.name }} {{ participant.person.title }} {{ participant.person.firstName }}
                    {{ participant.person.lastName }}
                </span>
                <span class="inner">
                    {{ participant.person.department }}
                </span>
            </div>
        </label>

        <a class="delete" (click)="removeParticipant(i)"
            ><span class="drg-icon-delete"></span><span class="text" [innerHTML]="'booking.bookingSummary.remove' | translate"></span
        ></a>
    </div>
</div>

<ng-template #overlay>
    <div class="embedcontainer">
        <ng-container *ngTemplateOutlet="warning"></ng-container>
    </div>
</ng-template>
<ng-template #warning>
    <div class="warning-popup">
        <div class="inner-wrapper">
            <div class="details">
                <h3 [innerHTML]="'booking.bookingSummary.deleteParticipantTitle' | translate"></h3>
                <p [innerHTML]="'booking.bookingSummary.deleteParticipantText' | translate"></p>
                <div class="button-wrapper">
                    <a
                        (click)="cancleOrder()"
                        class="button secondary"
                        [innerHTML]="'booking.bookingSummary.deleteParticipantBtn' | translate"
                    ></a>
                    <a
                        (click)="goToEditParticipants()"
                        class="button primary"
                        [innerHTML]="'booking.bookingSummary.cancleDeleteParticipant' | translate"
                    ></a>
                </div>
            </div>
        </div>
    </div>
</ng-template>
